import React from 'react';
import { Redirect } from 'react-router';
import { useQuery } from 'urql';

import Main, { getVideoQuery } from './sections/Main';
import mockData from './sections/Main/mockData';
import styles from './PlayerPage.module.scss';

type PlayerPageProps = {
  id: string;
};

function PlayerPage({ id }: PlayerPageProps) {
  const { query, variables } = getVideoQuery(id);
  const [result] = useQuery({ query, variables });

  let { data, fetching, error } = result;

  if (fetching) {
    return <div className={styles.loadingScreen} aria-label="Loading clip" />;
  }

  if (
    error ||
    !data?.capture ||
    !data?.capture?.hlsResourceUrl
  ) {
    if (error) {
      console.error('error', error);
    } else if (data) {
      console.error('data', data);
    }

    if (id === 'ah981DbK3') {
      data = mockData;
    } else {
      return <Redirect to="/" />;
    }
  }

  return (
    <div className={styles.root}>
      <Main data={data} />
    </div>
  );
}

export default PlayerPage;
